import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'

//格式化
import Formatter from './formatter/formatter'

Vue.use(VueI18n);

let langNow;
if (!window.localStorage.getItem('language')) {
  langNow = 'zh';
  localStorage.setItem('language','zh' );
}

const locale = window.localStorage.getItem('language');
const formatter = new Formatter({ locale });
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

const i18n = new VueI18n({

  locale, // set locale
  //set filter
  formatter,
  // set locale messages
  messages
});

export default i18n



// WEBPACK FOOTER //
// ./src/api/lang/index.js